export interface TelegramWebApp {
    initData?: string;
    initDataUnsafe?: {
        start_param?: string;
    };
    postEvent: (eventType: string, data: Record<string, string>) => void;
    openTelegramLink: (url: string) => void;
}

declare global {
    interface Window {
        Telegram?: {
            WebApp?: TelegramWebApp;
        };
    }
}

export const getTelegramWebApp = (): TelegramWebApp | undefined => window.Telegram?.WebApp;

export const isTelegramMiniApp = (): boolean => Boolean(getTelegramWebApp()?.initData?.trim());

export const getTelegramInitData = (): string => getTelegramWebApp()?.initData?.trim() || '';
